export default __webpack_public_path__ + "assets/images/474d9a0823672a672e3d8c872cdc0cb1.svg";